<script setup lang="ts">
defineProps<{
  id?: string
  title?: string
}>()
</script>

<template>
  <svg
    :id="id || 'logo'"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1200 416.92"
    width="1200"
    height="416.92"
    role="img"
    aria-hidden="true"
    data-testid="svgLogo"
  >
    <title v-if="title" v-text="title" />
    <path
      fill="currentColor"
      d="M292.45,7.53a24,24,0,0,0-24,24V245.28c0,63.18-34,98-95.65,98s-95.66-34.8-95.66-98V31.51a24,24,0,0,0-24-24H24a24,24,0,0,0-24,24V249.34c0,104.75,64.61,167.3,172.81,167.3s172.8-62.55,172.8-167.3V31.51a24,24,0,0,0-24-24Zm440.48,33h0a79.39,79.39,0,0,1-17,49.05L520,338.92H706.46a26.47,26.47,0,0,1,26.47,26.47V382.9a26.47,26.47,0,0,1-26.47,26.48H447.89a29.24,29.24,0,0,1-29.25-29.24h0a90.32,90.32,0,0,1,19.3-55.8L631.54,78H443.77a24.55,24.55,0,0,1-24.55-24.55V32.08A24.55,24.55,0,0,1,443.77,7.53H699.9A33,33,0,0,1,732.93,40.56Zm427.2,41.33c25.37,34.39,39.87,77.78,39.87,126.56,0,120.8-88.89,208.47-211.37,208.47a231.44,231.44,0,0,1-75.39-12.2,18,18,0,0,1-8.4-28l25.53-32.62a17.85,17.85,0,0,1,19-6.2,142.46,142.46,0,0,0,39.31,5.4c77,0,130.74-55.43,130.74-134.81,0-26.33-5.92-50-16.65-69.94a15.21,15.21,0,0,1,1.51-16.56l31.55-40.31A15.31,15.31,0,0,1,1160.13,81.89ZM894.89,111.08C918.54,87,951.83,73.66,988.63,73.66a144.25,144.25,0,0,1,40,5.45,17.74,17.74,0,0,0,18.87-6.2L1073,40.18a17.78,17.78,0,0,0-8.06-27.72A231.86,231.86,0,0,0,988.63,0C866.33,0,777.56,87.67,777.56,208.45c0,46.59,13.19,88.25,36.43,121.85a20,20,0,0,0,32.28.92l25.64-32.94a20.15,20.15,0,0,0,1.88-21.7c-10.38-19.92-15.89-43.21-15.89-68.13C857.9,170,871,135.43,894.89,111.08Z"
    />
  </svg>
</template>
